import styled from 'styled-components'

import { Container } from 'components/Container'

export const StyledSubscriptionDetails = {
  Container: styled(Container)`
    padding-bottom: 88px;
  `,
}
